import React from "react";
import Pagination from "../Pagination";

const ProductTable = ({ data, currentPage, totalPages, onPageChange }) => {
  return (
    <div className="overflow-x-auto">
      <table className="min-w-full bg-gray-700 text-white rounded-lg">
        <thead>
          <tr className="text-left border-b border-gray-600">
            <th className="px-4 py-3">#</th>
            <th className="px-4 py-3">Image</th>
            <th className="px-4 py-3">Name</th>
            <th className="px-4 py-3">Price</th>
            <th className="px-4 py-3">Type</th>
            <th className="px-4 py-3">Status</th>
            <th className="px-4 py-3">Actions</th>
          </tr>
        </thead>
        <tbody>
          {data && data.length > 0 ? (
            data.map((item, index) => (
              <tr
                key={index}
                className="border-b border-gray-600 hover:bg-gray-600 transition"
              >
                <td className="px-4 py-3">{index + 1}</td>
                <td className="px-4 py-3">
                    <img src={item.image} alt=""  className="w-[100px] h-[100px]"/>
                </td>
                <td className="px-4 py-3">{item.name}</td>
                <td className="px-4 py-3">{item.price}</td>
                <td className="px-4 py-3">{item.type}</td>
                <td className={`px-4 py-3`}>
                  <span
                    className={`p-2 rounded ${item.status === "Publish" ? "bg-green-500" : "bg-yellow-500"} text-white`}
                  >
                    {item.status}
                  </span>
                </td>

                <td className="px-4 py-3 align-middle">
  <div className="flex  items-center gap-2">
    <button className="px-2 py-1 bg-blue-500 rounded hover:bg-blue-600">
      Edit
    </button>
    <button className="px-2 py-1 bg-red-500 rounded hover:bg-red-600">
      Delete
    </button>
  </div>
</td>

              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={5} className="text-center py-4">
                No data found.
              </td>
            </tr>
          )}
        </tbody>
      </table>

      {/* Pagination */}
      <div className="mt-4 flex justify-center">
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={onPageChange}
        />
      </div>
    </div>
  );
};

export default ProductTable;
